<template>
  <footer class="footer">
    <div
      v-if="hasAboveFooter"
      class="footer__above"
    >
      <slot name="above-footer" />
    </div>
    <div
      v-if="!hideBottom"
      class="footer__background"
      :style="globalStylePrimaryColorBackground"
    >
      <div
        v-if="aboveButtonText"
        class="footer__above"
        :class="{ 'footer__above--italic': aboveButtonItalic }"
      >
        {{ aboveButtonText }}
      </div>
      <ButtonFdm
        inverse
        :bold="buttonTextBold"
        :text="buttonText"
        :path="buttonPath"
        :url="buttonUrl"
        :disabled="buttonDisabled"
        class="footer__button"
        @button-click="buttonClick"
      />
      <div
        v-if="buttonLoader"
        class="footer__loader"
      >
        <LoaderDualRings
          :total-size="4"
          :internal-ring-size="2.4"
          internal-ring-color="white"
          :external-ring-size="3.6"
          external-ring-color="white"
        />
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex'

import ButtonFdm       from '~/components/elements/ButtonFdm'
import LoaderDualRings from '~/components/loaders/DualRings'

import MixinPrimaryColor from '~/mixins/primaryColor'

export default {
  components: { ButtonFdm, LoaderDualRings },
  mixins: [MixinPrimaryColor],
  props: {
    buttonTextBold: Boolean,
    buttonText: {
      type: String,
      default: null,
    },
    buttonPath: {
      type: String,
      default: null,
    },
    buttonUrl: {
      type: String,
      default: null,
    },
    aboveButtonItalic: Boolean,
    aboveButtonText: {
      type: String,
      default: null,
    },
    buttonLoader: Boolean,
    buttonDisabled: Boolean,
    hideBottom: Boolean,
  },
  computed: {
    ...mapState('layout', ['isIframeOpen']),
    ...mapState('server', ['programName']),

    hasAboveFooter () {
      return this.$slots['above-footer'] && this.$slots['above-footer'].length !== 0
    },
  },
  watch: {
    aboveButtonText: 'updateFooterHeight',
    hasAboveFooter:  'updateFooterHeight',
    isIframeOpen:    'updateFooterHeight',
    $slots:          'updateFooterHeight',
  },
  mounted () {
    this.updateFooterHeight()
  },
  destroyed () {
    this.$store.commit('layout/setFooterHeight', null)
  },
  methods: {
    updateFooterHeight () {
      const height = this.$el.clientHeight
      this.$store.commit('layout/setFooterHeight', height + 'px')
    },
    buttonClick () {
      if (this.buttonDisabled) { return }

      this.$emit('button-click')
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~assets/css/variables";

.footer {
  z-index: $z-index-footer;
  background-color: #f8f8f8;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  padding-top: 0.5rem;
}
.footer__above {
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
}
.footer__above--italic {
  font-style: italic;
}
.footer__background {
  color: white;
  padding: 1rem;
}
.footer__loader {
  position: absolute;
  right: 1.5rem;
  bottom: 1.5rem;
}
</style>
